import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './components/home/home.component';
import { HomeRoutingModule } from './home-routing.module';
import { TranslocoModule } from '@ngneat/transloco';
import { PrimeNgModule } from '../../shared/modules/prime-ng.module';

@NgModule({
  declarations: [HomeComponent],
  imports: [CommonModule, HomeRoutingModule, TranslocoModule, PrimeNgModule],
})
export class HomeModule {}
